import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { addThresholdNotificationChanelMutation, addThresholdNotificationMutation, addUpdateCustomNotificationRulesMutation } from "../../graphql/mutations";
import { getNotificationRulesQuery, getThresholdNotificationChanelquery, getThresholdNotificationQuery } from "../../graphql/queries";
import { setLoader } from "../slices/locationSlice";
import { notificationFail, notificationSuccess } from "../slices/notificationSlice";

export const fetchThresholdNotificationThunk = createAsyncThunk('threshold-notification-fetch', async (_request: any, { dispatch }) => {

  try {
    const thresholdNotificationData = (await API.graphql({
      ...graphqlOperation(getThresholdNotificationQuery, {
        tenantCode: _request.tenant_code,
      }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; erros: any[] };
    return thresholdNotificationData?.data?.getThresholdNotification
  } catch (error) {

  }
})

export const addThresholdNotificationThunk = createAsyncThunk('add-threshold-notification', async (_request: any, { dispatch }) => {
  try {
    const addThresholdNotificationdData = (await API.graphql({
      ...graphqlOperation(addThresholdNotificationMutation, {
        threshold: _request
      }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; erros: any[] };
    if (addThresholdNotificationdData.data.addThresholdNotification.success == 'true') {
      dispatch(notificationSuccess('Threshold Level Updated'))
    }
    dispatch(fetchThresholdNotificationThunk({ tenant_code: _request.tenantCode }));
    dispatch(getThresholdChanelNotificationThunk({ tenant_code: _request.tenantCode }));
  } catch (error) {

  }
})

export const getThresholdChanelNotificationThunk = createAsyncThunk('get-chanel-threshold-notification', async (_request: any, { dispatch }) => {
  try {
    const thresholdNotificationChanelData = (await API.graphql({
      ...graphqlOperation(getThresholdNotificationChanelquery, {
        tenantCode: _request.tenant_code,
      }),
      authMode: "AMAZON_COGNITO_USER_POOLS",
    })) as { data: any; erros: any[] };
    return thresholdNotificationChanelData?.data?.getThresholdNotificationChanel[0]
  } catch (error) {

  }
})

export const addThresholdNotificationChannelThunk = createAsyncThunk(
  "channel-notification",
  async (_request: any, { dispatch }) => {
    try {     
      const chanelNotificationAddResposne = (await API.graphql({
        ...graphqlOperation(addThresholdNotificationChanelMutation, {
          channel: _request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; erros: any[] };

      if (
        chanelNotificationAddResposne.data.addThresholdNotificationChanel
          .success == "true"
      ) {
        dispatch(notificationSuccess("Threshold Channel Updated"));
      }

      // dispatch(getThresholdChanelNotificationThunk({tenant_code:_request.tenantCode}))
    } catch (error) {
      dispatch(
        getThresholdChanelNotificationThunk({
          tenant_code: _request.tenantCode,
        })
      );
    }
  }
);


export const getNotificationRulesThunk = createAsyncThunk(
  "getNotificationRules",
  async (_request: any, { dispatch }) => {
    try {
      const notificationRulesResposne = (await API.graphql({
        ...graphqlOperation(getNotificationRulesQuery, {
          ..._request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; erros: any[] };

      console.log('notificationRulesResposne', notificationRulesResposne);

      return notificationRulesResposne.data
    } catch (error) {
      console.log('error', error);
    }
  }
);
export const updateNotificationRulesThunk = createAsyncThunk(
  "updateNotificationRules",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      const notificationRulesResposne = (await API.graphql({
        ...graphqlOperation(addUpdateCustomNotificationRulesMutation, {
          notificationrules: _request,
        }),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: any; erros: any[] };

      console.log('ResultData', notificationRulesResposne);
      if (notificationRulesResposne.data.addUpdateCustomNotificationRules.success) {
        dispatch(notificationSuccess(notificationRulesResposne.data.addUpdateCustomNotificationRules.message))
      }
      else {
        dispatch(notificationFail("Something went wrong!"))
      }
      dispatch(setLoader(true));
      return notificationRulesResposne.data
    } catch (error) {
      dispatch(notificationFail("Something went wrong!"))
    }
  }
);



